<script setup lang="ts">
import { resolveComponent, computed } from 'vue';
import type { NavItem } from '@base-shared/types/navigation';

const props = withDefaults(
  defineProps<{
    link?: string | { name: string };
    tag?: string;
    navItem?: NavItem;
    activeRouteName?: string;
  }>(),
  {
    link: '/',
    tag: 'router-link'
  }
);

/**
 * Resolve component based on tag prop for router-link,
 * other wise pass the tag as native element.
 */
const component = computed(() => props.tag === 'router-link' ? resolveComponent(props.tag) : props.tag);

/**
 * Determine if linkAttr is 'to' for router-link or
 * 'href' for anchor tag. Null if neither.
 */
const linkAttr = computed(() => {
  if (props.tag === 'router-link') return 'to';
  if (props.tag === 'a') return 'href';

  return null;
});
</script>

<template>
  <component
    :is="component"
    v-bind="{
      ...(linkAttr ? { [linkAttr]: link } : {}),
    }"
    class="group flex items-center rounded-lg p-2 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
    :class="{
      'router-link-sub-route-active': activeRouteName && navItem?.subRouteNames?.includes?.(activeRouteName),
    }"
  >
    <slot name="icon" />

    <span
      class="flex-1 whitespace-nowrap"
      :class="$slots.icon && 'ml-3'"
    >
      <slot name="default" />
    </span>

    <slot name="suffix" />
  </component>
</template>
